import React from 'react';
import PropTypes from 'prop-types';
import BookingFormConsignmentOptions from './subComponents/BookingFormConsignmentOptions/BookingFormConsignmentOptions';
import BookingFormMisc from './subComponents/BookingFormMisc/BookingFormMisc';

const BookingFormAdvanced = ({ data, alter, freightsoftAddress }) => {
  return (
    <div className={'tab-content'}>
      <BookingFormConsignmentOptions data={data} alter={alter} />
      <BookingFormMisc data={data} alter={alter} freightsoftAddress={freightsoftAddress} />
    </div>
  );
};

BookingFormAdvanced.propTypes = {
  data: PropTypes.object,
  alter: PropTypes.func,
  freightsoftAddress: PropTypes.object,
};

export default BookingFormAdvanced;
